import ticketTypes from './ticketTypes'
import noteTypes from './noteTypes'
import roles from './roles'
import constants from './bluetooth/constants.ts'
import commands from './bluetooth/commands.ts'

/**
 * Ecoclean application settings
 */
export default {
  languages: ['en', 'de', 'it', 'es'],
  namespaces: [
    'admin',
    'cart',
    'equipmentInformation',
    'favorite',
    'feedback',
    'notification',
    'optionManagement',
    'team',
    'ticket',
  ],
  bannedMailDomains: [
    'ecoclean',
    'ucm-ag',
    'mhitraa',
  ],
  maximumPersistenceDays: 5,
  maximumPersistedRequestBytes: 1_048_576,
  maximumPersistedFileBytes: 1_048_576,
  suppressPing: false,
  showHomeBanner: true,
  showApmGo: true,
  suppressSupportedBy: true,
  suppressOrganisationCustomerNumber: true,
  suppressProductDevices: true,
  suppressScanButton: true,
  staticActions: [
    {
      options: { key: 'xEcoDivider', divider: true },
      route: { module: '', action: '' },
    },
    // See ECOCLEAN-115
    // {
    //   options: {
    //     key: 'xEcoConnect', label: 'Ecoclean Connect', icon: 'globe',
    //   },
    //   route: { module: 'xEcoApm', action: 'connect' },
    // },
    {
      options: {
        key: 'xEcoContacts', label: 'Ecoclean Contacts', icon: 'users',
      },
      route: { module: 'xEcoApm', action: 'contacts' },
    },
    {
      options: {
        key: 'xEcoPrivacy',
        label: 'Privacy Policy',
        icon: 'info',
      },
      url: {
        en: 'https://ecoclean-group.net/legal-information-data-protection',
        de: 'https://ecoclean-group.net/de/datenschutz',
        it: 'https://ecoclean-group.it/tutela-della-privacy',
        es: 'https://ecoclean-group.mx/informacion-legal-proteccion-de-datos',
      },
      route: { module: '', action: '' },
    },
    {
      options: { key: 'xEcoApmDivider', divider: true },
      route: { module: '', action: '' },
      aclContextRole: ['InstanceAdministrator'],
    },
    {
      options: {
        key: 'xEcoApm', label: 'APM Go!', icon: 'user', disabled: true,
      },
      route: { module: '', action: '' },
      aclContextRole: ['InstanceAdministrator'],
    },
    {
      options: {
        key: 'xEcoApmLicence', label: 'Licences',
      },
      route: { module: 'xEcoApm', action: 'licenceIndex' },
      aclContextRole: ['InstanceAdministrator'],
    },
    {
      options: {
        key: 'xEcoApmMeasurement', label: 'Measurements',
      },
      route: { module: 'xEcoApm', action: 'measurementIndex' },
      aclContextRole: ['InstanceAdministrator'],
    },
    {
      options: {
        key: 'xEcoApmSensor', label: 'Registered sensors',
      },
      route: { module: 'xEcoApm', action: 'sensorIndex' },
      aclContextRole: ['InstanceAdministrator'],
    },
  ],
  teamDefaultRoles: ['CustomerServiceAgent'],
  ticketTypes,
  noteTypes,
  roles,
  plugins: ['measurement'],
  apmTeaserUrl: 'https://apm-go.net/',
  bluetooth: {
    commands,
    constants,
  },
}
